import {useState, useEffect, createRef} from 'react';
import { doc, getDoc } from "firebase/firestore";
import { db } from '../../firebase';

import styles from "./EditingPage.module.css"

import Sidebar from "./Sidebar/Sidebar"
import BeautifulScreenshot from './BeautifulScreenshot/BeautifulScreenshot';
import ImageUploader from './ImageUploader/ImageUploader';
import ZoomInput from './ZoomInput/ZoomInput';

import { useAuth } from '../../contexts/authContext';

export default function EditingPage() {
  const ref = createRef(null);

  const searchParams = new URLSearchParams(window.location.href)

  const {currentUser} = useAuth()

  const [loading, setLoading] = useState(true);
  
  const [bgType, setBgType] = useState();
  const [bgValueGradient, setBgValueGradient] = useState();
  const [bgGradientRotation, setBgGradientRotation] = useState();
  const [bgValueSolid, setBgValueSolid] = useState();
  const [bgBorderRadius, setBgBorderRadius] = useState()
  const [imgBorderRadius, setImgBorderRadius] = useState()
  const [linkedPadding, setLinkedPadding] = useState(true);
  const [padding, setPadding] = useState();
  const [topPadding, setTopPadding] = useState();
  const [bottomPadding, setBottomPadding] = useState();
  const [leftPadding, setLeftPadding] = useState();
  const [rightPadding, setRightPadding] = useState();
  const [shadowEnabled, setShadowEnabled] = useState("on");
  const [shadowColor, setShadowColor] = useState("#000000");
  const [xOffset, setXOffset] = useState(2);
  const [yOffset, setYOffset] = useState(5);
  const [blurRadius, setBlurRadius] = useState(15);
  const [shadowOpacity, setShadowOpacity] = useState(40);
  const [userImage, setUserImage] = useState();

  const [bgSelected, setBgSelected] = useState(false);
  const [paddingSelected, setPaddingSelected] = useState(false);
  const [shadowSelected, setShadowSelected] = useState(false);

  const [zoom, setZoom] = useState(1)

  async function getDesignInfo() {
    const docRef = doc(db, "users", currentUser.uid);
    const docSnap = await getDoc(docRef);

    const data = docSnap.data().allDesigns;

    const designId = searchParams.get("designId");

    // if (!designId || !data[designId]) {
    //   navigate("/404")

    //   return;
    // }

    setBgType(data[designId].bgType);
    setBgValueGradient(data[designId].bgGradientColor)
    setBgGradientRotation(data[designId].bgGradientRotation || "45")
    setBgValueSolid(data[designId].bgSolidColor)
    setBgBorderRadius(data[designId].bgBorderRadius)
    setImgBorderRadius(data[designId].imgBorderRadius)
    setPadding(data[designId].bgPadding)
    setTopPadding(data[designId].bgTopPadding)
    setLeftPadding(data[designId].bgLeftPadding)
    setBottomPadding(data[designId].bgBottomPadding)
    setRightPadding(data[designId].bgRightPadding)
    setLinkedPadding(data[designId].bgLinkedPadding)
    setUserImage(data[designId].imgSrc)
    setXOffset(data[designId].imgShadow.xOffset)
    setYOffset(data[designId].imgShadow.yOffset)
    setShadowOpacity(data[designId].imgShadow.opacity)
    setBlurRadius(data[designId].imgShadow.blurRadius)
    setShadowColor(data[designId].imgShadow.color)
    setShadowEnabled(data[designId].imgShadow.enabled)

    setLoading(false)
  }

  function handleClick(e) {
    const elementClass = (e.target.getAttribute("class") && e.target.getAttribute("class").split(" ")[0]);
    const elementParentClass = (e.target.parentElement.getAttribute("class") && e.target.parentElement.getAttribute("class").split(" ")[0]);
    const elementParentParentClass = (e.target.parentElement.parentElement.getAttribute("class") && e.target.parentElement.parentElement.getAttribute("class").split(" ")[0]);
    const elementParentParentParentClass = (e.target.parentElement.parentElement.parentElement.getAttribute("class") && e.target.parentElement.parentElement.parentElement.getAttribute("class").split(" ")[0]);
    const elementParentParentParentParentClass = (e.target.parentElement.parentElement.parentElement.parentElement.getAttribute("class") && e.target.parentElement.parentElement.parentElement.parentElement.getAttribute("class").split(" ")[0]);
    const elementParentParentParentParentParentClass = (e.target.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute("class") && e.target.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute("class").split(" ")[0]);

    if (elementClass !== "optionsBtnOpener" && elementClass !== "optionsCard" && elementParentClass !== "optionsCard" && elementParentParentClass !== "optionsCard" && elementParentParentParentClass !== "optionsCard" && elementParentParentParentParentClass !== "optionsCard" && elementParentParentParentParentParentClass !== "optionsCard") {
      setBgSelected(false);
      setPaddingSelected(false);
      setShadowSelected(false);
    } else {
      const elementSpecificClass = e.target.getAttribute("class").split(" ")[1];

      if (elementSpecificClass === "bgBtn") {
        setBgSelected(!bgSelected);
        setPaddingSelected(false);
        setShadowSelected(false);
      } else if (elementSpecificClass === "paddingBtn") {
        setPaddingSelected(!paddingSelected);
        setBgSelected(false);
        setShadowSelected(false);
      } else if (elementSpecificClass === "shadowBtn") {
        setShadowSelected(!shadowSelected);
        setBgSelected(false);
        setPaddingSelected(false);
      }
    }
  }

  useEffect(() => {
    getDesignInfo()
  }, [loading])

  return (
    <section className={styles.editingPage} onMouseDown={handleClick}>
      {!loading &&
        <>
          <Sidebar
            bgType={bgType}
            bgBorderRadius={bgBorderRadius}
            imgBorderRadius={imgBorderRadius}
            bgValueGradient={bgValueGradient}
            bgValueSolid={bgValueSolid}
            padding={padding}
            topPadding={topPadding}
            bottomPadding={bottomPadding}
            leftPadding={leftPadding}
            rightPadding={rightPadding}
            setBgType={setBgType}
            setBgBorderRadius={setBgBorderRadius}
            setImgBorderRadius={setImgBorderRadius}
            linkedPadding={linkedPadding}
            setLinkedPadding={setLinkedPadding}
            setPadding={setPadding}
            setTopPadding={setTopPadding}
            setBottomPadding={setBottomPadding}
            setLeftPadding={setLeftPadding}
            setRightPadding={setRightPadding}
            setBgValueGradient={setBgValueGradient}
            bgValueGradient={bgValueGradient}
            setBgValueSolid={setBgValueSolid}
            bgValueSolid={bgValueSolid}
            setShadowEnabled={setShadowEnabled}
            setShadowColor={setShadowColor}
            shadowEnabled={shadowEnabled}
            shadowColor={shadowColor}
            xOffset={xOffset}
            yOffset={yOffset}
            blurRadius={blurRadius}
            setXOffset={setXOffset}
            setYOffset={setYOffset}
            setBlurRadius={setBlurRadius}
            shadowOpacity={shadowOpacity}
            setShadowOpacity={setShadowOpacity}
            testRef={ref}
            bgSelected={bgSelected}
            setBgSelected={setBgSelected}
            paddingSelected={paddingSelected}
            setPaddingSelected={setPaddingSelected}
            shadowSelected={shadowSelected}
            setShadowSelected={setShadowSelected}
            bgGradientRotation={bgGradientRotation}
            setBgGradientRotation={setBgGradientRotation}
          />

          <BeautifulScreenshot
            zoom={zoom}
            bgType={bgType}
            bgBorderRadius={bgBorderRadius}
            imgBorderRadius={imgBorderRadius}
            linkedPadding={linkedPadding}
            padding={padding}
            topPadding={topPadding}
            bottomPadding={bottomPadding}
            leftPadding={leftPadding}
            rightPadding={rightPadding}
            bgValueGradient={bgValueGradient}
            bgValueSolid={bgValueSolid}
            shadowEnabled={shadowEnabled}
            shadowColor={shadowColor}
            xOffset={xOffset}
            yOffset={yOffset}
            blurRadius={blurRadius}
            shadowOpacity={shadowOpacity}
            userImage={userImage}
            setUserImage={setUserImage}
            setBgValueSolid={setBgValueSolid}
            setBgValueGradient={setBgValueGradient}
            testRef={ref}
            bgGradientRotation={bgGradientRotation}
          />

          <ImageUploader setUserImage={setUserImage} userImage={userImage} testRef={ref} />

          {/* <ZoomInput setZoom={setZoom}/> */}
        </>
      }
    </section>
  );
}
